var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoaded && (_vm.loggedIn || _vm.isAnonymous)
    ? _c(
        "div",
        [
          _c("AppHeader"),
          _c(
            "v-main",
            [
              _c("router-view", { key: _vm.routeViewKey }),
              _c("snack-stack"),
              _c("dynamic-dialog"),
              _c("loading-dialog")
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }